import styled from 'styled-components';

export const DivTituloDoPost = styled.div`
    font-size:40px;
`

export const DivImagemDoPost = styled.div`
    margin: 80px 0 40px 0;
    >img{
        max-width:100%;
    }

`
export const DivTextoDoPost = styled.div`
    width:70%;
    line-height:30px;
    font-size:20px;
    text-align:initial;

    @media(max-width:800px){
        font-size:18px;
        width:100%;
        padding:0 20px;
    }

`
export const DivFooter = styled.div`
    display:grid;
    grid-template-columns:50% 50%;
    padding:0 80px;
    margin:50px 0;
    @media(max-width:800px){
        width:100%;
        padding:10px;
    }
`
export const SpanNavegacao  = styled.span`
    font-size:30px;
    margin-left:10px;
    @media(max-width:800px){
        font-size:20px;
    }
;
`
